import React, { useContext, useEffect, useState } from "react";
import "./CadCadastro.scss";
import useLoading from "@hooks/useLoading";
import GlobalContext from "@context/GlobalContext";
import { useNavigate } from "react-router-dom";
import usePermissoes from "@hooks/usePermissoes";
import UtilServices from "@services/UtilServices";
import FormCadastro from "@components/formCadastro/FormCadastro";
import EndPointServices from "@services/ApiServices";
import MessageServices from "@services/MessageServices";
import Button from "@components/button/Button";
import useLst from "@hooks/useLst";

const CadCadastro = () => {
  //State Padrões
  const [state, dispatch] = useContext(GlobalContext);
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();
  const [setLoading] = useLoading();
  //Lista dos Menus.
  const { lstNacionalidade } = useLst();

  //DropDownlist Municipios + uf
  const [municipio, setMunicipios] = useState([]);
  const [loadingDrop, setLoadingDrop] = useState(false);

  //DropDownlist cnae
  const [cnaeLst, setCnaeLst] = useState([]);
  const [loadingDropCnae, setLoadingDropCnae] = useState(false);

  //DropDownlist tipo telefone
  const [tpTelefone, setTpTelefone] = useState([]);
  const [loadingTpTelefone, setLoadingTpTelefone] = useState(false);

  //defaultValueLst
  const [defaultValueLstEmpresa, setDefaultValueLstEmpresa] = useState([]);
  const [defaultValueLstEndereco, setDefaultValueLstEndereco] = useState([]);
  const [defaultValueLstTelefone, setDefaultValueLstTelefone] = useState([]);
  const [defaultValueLstSocio, setDefaultValueLstSocio] = useState([]);

  //Lista Submit
  const [submit, setSubmit] = useState([]);
  const [limpar, setLimpar] = useState([]);

  //Pagina de Edição
  const [editEmpresa, setEditEmpresa] = useState(false);
  const [editEndereco, setEditEndereco] = useState(false);
  const [editSocio, setEditSocio] = useState(false);
  const [editDadosSocio, setEditDadosSocio] = useState(false);

  //Pagina Criação
  const [criarEndereco, setCriarEndereco] = useState(false);
  const [criarSocio, setCriarSocio] = useState(false);
  const [criarDadosSocio, setCriarDadosSocio] = useState(false);

  //cnpj /socio/endereco em andamento.
  const [cnpj, setCnpj] = useState("");
  const [idSocio, setIdSocio] = useState("");
  const [idEndereco, setIdEndereco] = useState("");
  const [idEmpresa, setIdEmpresa] = useState("");

  useEffect(() => {
    //NOVOS
    if (Object.values(state.novoselecionado).length > 0) {
      //Novo Socio
      if (state.novoselecionado?.novo === "novosocio") {
        setCriarSocio(true);
        setCnpj(state.novoselecionado?.cnpj); //Necessário para identificar quem está vinculado ao cnpj;
        setDefaultValueLstEmpresa({
          cnpj: UtilServices.maskCNPJ(state.novoselecionado?.cnpj),
        });
      } else if (state.novoselecionado?.novo === "novoendereco") {
        setCriarEndereco(true);
        //CNPJ
        if (state.novoselecionado?.cnpj) {
          setDefaultValueLstEmpresa({
            cnpj: UtilServices.maskCNPJ(state.novoselecionado?.cnpj),
          });
          setCnpj(state.novoselecionado?.cnpj); //Necessário para identificar quem está vinculado ao cnpj;
        }
        //SOCIO
        else if (state.novoselecionado?.cpf) {
          setDefaultValueLstSocio({
            cpf: UtilServices.maskCPF(state.novoselecionado?.cpf),
          });
          setIdSocio(state.novoselecionado?.ID_Empresa_Socio); //Necessário para identificar quem está vinculado ao socio;
        }
        //Dados do socio
      } else if (state.novoselecionado?.novo === "dadossocio") {
        setDefaultValueLstSocio({
          cpf: UtilServices.maskCPF(state.novoselecionado?.cpf),
        });
        setIdSocio(state.novoselecionado?.ID_Empresa_Socio); //Necessário para identificar quem está vinculado ao socio;
        setCriarDadosSocio(true);
      }
    }
    //EDIÇÕES
    //Editar Empresa
    else if (Object.values(state.empresaselecionada).length > 0) {
      handleEditEmpresa(state.empresaselecionada, true);
    }
    //Editar endereço
    else if (Object.values(state.enderecoselecionado).length > 0) {
      handleEditEndereco(state.enderecoselecionado, true);
      setIdEndereco(state.enderecoselecionado?.ID_Endereco);
      setCnpj(state.enderecoselecionado?.cnpj); //Necessário para identificar quem está vinculado ao cnpj;
      setIdSocio(state.enderecoselecionado?.ID_Empresa_Socio); //Necessário para identificar quem está vinculado ao socio;
    }
    //Editar socio
    else if (Object.values(state.socioselecionado).length > 0) {
      handleEditSocio(state.socioselecionado, true);
      setIdSocio(state.socioselecionado?.ID_Empresa_Socio); //Necessário para identificar quem está vinculado ao socio;
    }
    //Editar dados do socio
    else if (Object.values(state.sociodadosselecionado).length > 0) {
      handleEditDadosSocio(state.sociodadosselecionado, true);
      setIdSocio(state.sociodadosselecionado?.ID_Empresa_Socio); //Necessário para identificar quem está vinculado ao socio;
      setIdEmpresa(state.sociodadosselecionado?.ID_Empresa); //Necessário para identificar quem está vinculado ao socio;
    }

    handleConsultaTipoContato_DropDownLst();

    return () => {
      handleClearVariaveis();
    };
  }, []);

  /*--- Api Externas---*/
  async function handleGetMunicipiosUF() {
    setLoadingDrop(true);

    let retornoApi = await EndPointServices.Externo_ConsultaMunicipios();
    const formattedMunicipio = [
      ...new Map(
        retornoApi.map((municipio) => [
          municipio.id,
          {
            id: municipio.id,
            key: `${municipio?.nome} - ${municipio?.microrregiao?.mesorregiao?.UF?.sigla}`,
          },
        ]),
      ).values(),
    ];

    setMunicipios(formattedMunicipio);
    setLoadingDrop(false);
  }
  async function handleGetCNAES() {
    setLoadingDropCnae(true);

    let retornoApi = await EndPointServices.Externo_ConsultaCnaes();
    const formattedcnae = [
      ...new Map(
        retornoApi.cnaes.map((cnae) => [
          cnae.codigo,
          {
            id: cnae?.codigo,
            key: `${cnae?.codigo} - ${cnae?.descricao}`,
          },
        ]),
      ).values(),
    ];

    setCnaeLst(formattedcnae);
    setLoadingDropCnae(false);
  }
  async function handleGetCEP(cep) {
    if (!cep) {
      MessageServices.ShowError("CEP não pode ser vazio!");
      return;
    }

    if (!UtilServices.validateCEP(cep)) {
      MessageServices.ShowError("CEP inválido!");
      return;
    }

    setLoading(true);

    let retornoApi = await EndPointServices.Externo_ConsultaCEP(
      cep.replace(/\D/g, ""),
    );

    setLoading(false);

    return retornoApi;
  }
  async function handleGetReceitaWS(cnpj) {
    if (!cnpj) {
      MessageServices.ShowError("CNPJ não pode ser vazio!");
      return;
    }

    if (!UtilServices.validateCNPJ(cnpj)) {
      MessageServices.ShowError("CNPJ inválido!");
      return;
    }
    setLoading(true);

    let data = {
      cnpj: cnpj.replace(/\D/g, ""),
    };

    let retornoApi = await EndPointServices.Externo_ConsultaCnpj(data);
    if (retornoApi.Success) {
      setLoading(false);
      return { ...retornoApi?.BaseReturn?.LstClasse };
    } else if (!retornoApi.Success) {
      MessageServices.ShowError(retornoApi.Message);
    }

    setLoading(false);
  }

  /*--- Funções botão pesquisa---*/
  async function handlePesquisaCEP(cep) {
    let resp = await handleGetCEP(cep);
    if (resp) {
      let retornoget = {
        bairro: resp?.bairro,
        municipio: `${resp?.estado} - ${resp?.uf}`,
        uf: resp?.uf,
        complemento: resp?.complemento,
        logradouro: resp?.logradouro,
      };

      let retorno = handleEncontrarPais(retornoget);

      return retorno;
    }
  }
  async function handlePesquisaCNPJ(cnpj) {
    let resp = await handleGetReceitaWS(cnpj);
    if (resp?.[0]) {
      handleEditEmpresa(resp[0], false);
      handleEditEndereco(resp[0], false);
      handleEditTelefone(resp[0]);
    }
  }
  async function handlePesquisaEnderecoSocio(cep) {
    let resp = await handlePesquisaCEP(cep);
    handleEditSocio(resp, editSocio ? true : false, true);
  }
  async function handlePesquisaEndereco(cep) {
    let resp = await handlePesquisaCEP(cep);
    handleEditEndereco(resp, editEndereco ? true : false, true);
  }

  /*--- Funções para Edição---*/
  async function handleEditEmpresa(dados, editar = false) {
    setEditEmpresa(editar);

    let retornoget = [];

    if (editar) {
      retornoget = await handleConsultarDetalhadaEmpresa(dados);
      setDefaultValueLstEmpresa({
        cnpj: UtilServices.maskCNPJ(retornoget?.CNPJ),
        cpf: retornoget?.CPF_Administrador,
        apelido: retornoget?.Apelido,
        razaosocial: retornoget?.Razao_Social,
        inscricaoestadual: retornoget?.Cod_Inscricao_Estadual,
        nomefantasia: retornoget?.Nome_Fantasia,
        situacao: retornoget?.Situacao,
        dtsituacao: retornoget?.Dt_Situacao,
        tributacao: retornoget?.Tributacao,
        optantepelosimples: retornoget?.Optante_Simples,
        dtentrada: retornoget?.Dt_Entrada,
        dtabertura: retornoget?.Dt_Abertura,
        codigoccm: retornoget?.Cod_CCM,
        segmento: retornoget?.Segmento,
        capitalsocial: retornoget?.Capital_Social,
        porte: retornoget?.Porte,
        tipo: retornoget?.Tipo,
        cnae: retornoget?.CNAE_Principal,
        nire: retornoget?.Cod_Nire,
        naturezajuridica: retornoget?.Cod_Natureza_Juridica,
        possuifolha: retornoget?.Possui_Folha_Pagamento,
        situacaofinanceira: retornoget?.Situacao_Financeira,
        situacaofinanceirareceita: retornoget?.Situacao_Financeira_Receita,
        observacao: retornoget?.Observacao,
      });
    } else {
      //quando vier da receitaws
      setDefaultValueLstEmpresa({
        razaosocial: dados?.nome,
        nomefantasia: dados?.fantasia,
        situacao: dados?.situacao,
        dtsituacao: dados?.data_situacao,
        tributacao: dados?.simples?.optante ? "Simples Nacional" : "",
        optantepelosimples: dados?.simples?.optante
          ? "Sim"
          : dados?.simples?.optante === false
          ? "Não"
          : "",
        dtabertura: dados?.abertura,
        capitalsocial: dados?.capital_social
          ? UtilServices.maskCurrency(dados?.capital_social)
          : "",
        porte: dados?.porte,
        tipo: dados?.tipo,
        cnae: dados?.atividade_principal?.[0]?.code
          ? `${dados.atividade_principal[0].code.replace(/\D/g, "")} - ${
              dados.atividade_principal[0].text
            }`
          : "",
        cnaesecundario: dados?.atividades_secundarias?.[0]?.code
          ? dados?.atividades_secundarias?.map((item) => ({
              cnaesecundario: `${item.code?.replace(/[\.\-]/g, "")} - ${
                item?.text
              }`,
            }))
          : "",
        naturezajuridica: dados?.natureza_juridica,
        situacaofinanceirareceita: dados?.status,
      });
    }
  }
  function handleEditEndereco(dados, editar = false, buscaCep = false) {
    setEditEndereco(editar);
    if (buscaCep) {
      setDefaultValueLstEndereco({
        bairro: dados?.bairro,
        municipio: dados?.municipio,
        complemento: dados?.pais,
        logradouro: dados?.logradouro,
        numero: " ", //passando o valor assim ele consegue mudar para nulo o campo
        pais: dados?.pais,
        tipoendereco: " ", //passando o valor assim ele consegue mudar para nulo o campo
      });
    } else if (editar) {
      setDefaultValueLstEndereco({
        cep: dados?.Cep ? UtilServices.maskCEP(dados?.Cep) : "",
        bairro: dados?.Bairro,
        municipio: `${dados?.Cidade} - ${dados?.Estado}`,
        complemento: dados?.Complemento,
        logradouro: dados?.Logradouro,
        numero: dados?.Numero,
        pais: dados?.Pais,
        tipoendereco: dados["Tipo Endereço"],
      });
    } else {
      //quando vier da receitaws
      let retornoget = {
        cep: dados?.cep ? UtilServices.maskCEP(dados?.cep) : "",
        bairro: dados?.bairro,
        municipio: dados?.municipio ? `${dados?.municipio} - ${dados?.uf}` : "",
        complemento: dados?.complemento,
        logradouro: dados?.logradouro,
        numero: dados?.numero,
      };

      let retorno = handleEncontrarPais(retornoget);
      setDefaultValueLstEndereco(retorno);
    }
  }
  async function handleEditSocio(dados, editar = false, buscaCep = false) {
    setEditSocio(editar);

    if (buscaCep) {
      setDefaultValueLstSocio((prevValues) => ({
        ...prevValues, // Mantém os valores anteriores
        ...dados, // Acrescenta ou sobrescreve os novos valores
      }));
    } else if (editar) {
      let retornoget = await handleConsultarDetalhadaSocio(dados);

      setDefaultValueLstSocio({
        nomecompleto: retornoget?.[0]?.nomecompleto,
        cpf: UtilServices.maskCPF(retornoget?.[0]?.cpf),
        sexo: retornoget?.[0]?.sexo,
        rg: retornoget?.[0]?.rg,
        dtnascimento: retornoget?.[0]?.dtnascimento,
        nacionalidade: retornoget?.[0]?.nacionalidade,
        municipionascimento: retornoget?.[0]?.municipionascimento,
        profissao: retornoget?.[0]?.profissao,
        estadocivil: retornoget?.[0]?.estadocivel,
        pis: retornoget?.[0]?.pis,
        tituloeleitor: retornoget?.[0]?.tituloeleitor,
        dtinclusao: retornoget?.[0]?.dtinclusao,
        dtexclusao: retornoget?.[0]?.dtexclusao,

        //Endereco
        logradouro: retornoget?.[0]?.logradouro,
        numero: retornoget?.[0]?.numero,
        complemento: retornoget?.[0]?.complemento,
        bairro: retornoget?.[0]?.bairro,
        municipio: retornoget?.[0]?.municipio,
        cep: UtilServices.maskCEP(retornoget?.[0]?.cep),
        pais: retornoget?.[0]?.pais,
        tipoendereco: retornoget?.[0]?.tipoendereco,
      });
    } else {
      //quando vier da receitaws
      setDefaultValueLstSocio({
        ...dados,
        nomecompleto: dados?.qsa?.[0]?.nome || "",
        socioresponsavel: dados?.qsa?.[0]?.qual
          ? dados.qsa[0].qual === "49-Sócio-Administrador"
            ? "Sim"
            : "Não"
          : "",
      });
    }
  }
  async function handleEditDadosSocio(dados, editar = false) {
    setEditDadosSocio(editar);

    if (editar) {
      setDefaultValueLstSocio({
        cpf: UtilServices.maskCPF(dados?.cpf),
        cnpj: UtilServices.maskCNPJ(dados?.CNPJ),
        dtinclusao: dados?.["Data Inclusão"],
        dtexclusao: dados?.["Data Exclusão"],
        participacaocapital: dados?.["Participação Capital"],
        porcentagemlucro: dados?.["Porcentagem Lucro"],
        status: dados?.["Status"],
        socioresponsavel: dados?.["Sócio Administrador"],
        valorbrutoprolabore: dados?.["Valor Bruto Prolabore"],
        datapagamentoprolabore: dados?.["Período Referente ao Prolabore"],
      });
    }
  }
  function handleEditTelefone(dados) {
    setDefaultValueLstTelefone({
      telefone: dados?.telefone,
      email: dados?.email,
    });
  }

  /*--- Funções para Consultas/DropDownLst---*/
  async function handleConsultaTipoContato_DropDownLst() {
    setLoadingTpTelefone(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      id: 1,
    };

    try {
      var retornoapi = await EndPointServices.Partilha_ConsultarLista(data);
      if (retornoapi.Success) {
        setTpTelefone([
          ...retornoapi?.BaseReturn?.LstClasse.map((item) => ({
            id: item.ID_Tipo_Contato,
            key: item.Descricao,
          })),
        ]);
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoadingTpTelefone(false);
  }
  async function handleConsultarDetalhadaEmpresa(dados) {
    setLoading(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { CNPJ: dados.CNPJ },
    };

    try {
      var retornoapi = await EndPointServices.CAD_EmpresaDetalhadaConsultar(
        data,
      );
      if (retornoapi.Success) {
        setLoading(false);

        return { ...retornoapi?.BaseReturn?.LstClasse[0] };
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoading(false);
  }
  async function handleConsultarDetalhadaSocio(dados) {
    setLoading(true);

    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      socio: { ID_Empresa_Socio: dados.ID_Empresa_Socio },
    };

    try {
      var retornoapi = await EndPointServices.CAD_SocioDetalhadaConsultar(data);
      if (retornoapi.Success) {
        setLoading(false);
        return { ...retornoapi?.BaseReturn?.LstClasse };
      }
    } catch (ex) {
      console.log(ex);
    }

    setLoading(false);
  }

  /*--- Funções para Cadastrar---*/
  async function handleAdicionar() {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { ...submit },
    };

    // dispatch({
    //   type: "SET_NOVOSELECIONADO",
    //   payload: {
    //     novo: "novaempresa",
    //   },
    // });

    try {
      //Novo socio
      if (state.novoselecionado?.novo === "novoendereco") {
        var retornoapi = await EndPointServices.CAD_EnderecoAdicionar(data);
        if (retornoapi.Success) {
          MessageServices.ShowSuccess("Novo endereço adicionado com sucesso!");
          navigate("/CAD");
          setLimpar(true);
        }
      } else if (state.novoselecionado?.novo === "novosocio") {
        var retornoapi = await EndPointServices.CAD_SocioAdicionar(data);
        if (retornoapi.Success) {
          MessageServices.ShowSuccess("Novo sócio adicionado com sucesso!");
          navigate("/CAD");
          setLimpar(true);
        }
        //Nova Empresa
      } else if (state.novoselecionado?.novo === "novaempresa") {
        var retornoapi = await EndPointServices.CAD_EmpresaAdicionar(data);
        if (retornoapi.Success) {
          MessageServices.ShowSuccess("Empresa adicionada com sucesso!");
          navigate("/CAD");
          setLimpar(true);
        }
      } else if (state.novoselecionado?.novo === "dadossocio") {
        var retornoapi = await EndPointServices.CAD_SocioAdicionar(data);
        if (retornoapi.Success) {
          MessageServices.ShowSuccess("Dados do sócio adicionado com sucesso!");
          navigate("/CAD");
          setLimpar(true);
        }
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoading(false);
  }

  /*--- Funções para Editar ---*/
  async function handleEditar() {
    setLoading(true);
    let data = {
      ID_Usuario: state?.dadosusuario?.ID_Usuario,
      ID_Usuario_Log: state?.dadosusuario?.ID_Usuario_Log,
      empresa: { ...submit },
    };
    try {
      let retornoapi = [];

      if (editDadosSocio || editSocio || (editEndereco && idSocio)) {
        retornoapi = await EndPointServices.CAD_SocioEditar(data);
      } else if (editEmpresa || (editEndereco && cnpj)) {
        retornoapi = await EndPointServices.CAD_EmpresaEditar(data);
      }

      if (retornoapi.Success) {
        MessageServices.ShowSuccess("Dados atualizados com sucesso!");
        navigate("/CAD");
      }
    } catch (ex) {
      console.log(ex);
    }
    setLoading(false);
  }

  /*--- Outras ---*/
  //Função para disabled botão salvar
  function handleDisabledSalvar() {
    /*--- EDITAR ---*/
    //Editar Empresa
    if (editEmpresa && submit?.dadosempresa?.length > 0) {
      return false; //false habilita o botão
    }
    //Editar Endereco
    if (editEndereco && submit?.endereco?.length > 0) {
      return false; //false habilita o botão
    }
    //Editar Socio
    if (editSocio && submit?.socio?.length > 0) {
      return false; //false habilita o botão
    }
    //Editar Socio
    if (editDadosSocio && submit?.dadossocio?.length > 0) {
      return false; //false habilita o botão
    }

    /*--- CADASTRAR ---*/
    //Cadastrar Empresa
    if (submit?.dadosempresa?.length > 0 && submit?.endereco.length > 0) {
      return false; //false habilita o botão
    }
    //Cadastrar Socio
    if (criarSocio && submit?.socio?.length > 0) {
      return false; //false habilita o botão
    }
    //Cadastrar Endereco
    if (criarEndereco && submit?.endereco?.length > 0) {
      return false; //false habilita o botão
    }
    //Cadastrar Dadios dos socio
    if (criarDadosSocio && submit?.dadossocio?.length > 0) {
      return false; //false habilita o botão
    }

    return true; //true desabilita o botão
  }
  //Encontrar Pais
  function handleEncontrarPais(LstClasse) {
    const ufsValidas = municipio.map((item) => item.key.split(" - ")[1]); // Extrai apenas as UFs únicas

    return {
      ...LstClasse,
      pais: ufsValidas.includes(LstClasse?.uf?.toUpperCase())
        ? "Brasil"
        : "Desconhecido",
    };
  }
  //Validação para identificar o cnpj
  function handleInsertSubmit(key, e) {
    if (!cnpj && !idSocio) {
      MessageServices.ShowError(
        `Erro ao encontrar um CNPJ ou Socio vinculado ao ${key}`,
      );
      return;
    }

    setSubmit((prevState) => ({
      ...prevState,
      [key]: [
        {
          ...e,
          ...(cnpj ? { cnpj } : {}), // Adiciona cnpj apenas se existir
          ID_Empresa_Socio: idSocio,
          ID_Empresa: idEmpresa,
          ID_Endereco: idEndereco,
        },
      ],
    }));
  }
  //Limpar variaveis de edição ao sair da tela
  function handleClearVariaveis() {
    //Editar
    setEditEmpresa(false);
    setEditEndereco(false);
    setEditSocio(false);
    setEditDadosSocio(false);
    setCnpj("");
    setIdSocio("");
    setIdEndereco("");
    setIdEmpresa("");
    //Criar
    setCriarSocio(false);
    setCriarEndereco(false);
    //states
    dispatch({ type: "SET_EMPRESASELECIONADA", payload: [] });
    dispatch({ type: "SET_ENDERECOSELECIONADO", payload: [] });
    dispatch({ type: "SET_SOCIOSELECIONADO", payload: [] });
    dispatch({ type: "SET_SOCIODADOSSELECIONADO", payload: [] });
    dispatch({ type: "SET_NOVOSELECIONADO", payload: {} });
  }
  function handleOcultarCampo(campo, lst) {
    if (campo === "cnpj" && lst === "endereco") {
      if (criarEndereco && cnpj) {
        return false;
      }
    } else if (campo === "cpf" && lst === "endereco") {
      if (criarEndereco && idSocio) {
        return false;
      }
    } else if (campo === "cpf" && lst === "dadossocio") {
      if (criarDadosSocio && idSocio) {
        return false;
      }
    }
    return true;
  }

  /*---Lst Empresa--*/
  const lstEmpresa = [
    {
      title: "*CNPJ",
      placeholder: "00.000.000/0000-00",
      mask: "CNPJ",
      maxLength: 18,
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cnpj",
      required: "CNPJ é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCNPJ,
      isValidDesc: "CNPJ inválido",
      //Button
      button: editEmpresa ? false : true,
      iconButton: "pesquisar",
      titleButton: "Pesquisar Dados CNPJ",
      typeButton: "button",
      onClickButton: handlePesquisaCNPJ,
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Digite o CNPJ e clique no ícone de pesquisa para buscar e preencher os campos automaticamente!",
      //Default
      defaultValue: defaultValueLstEmpresa?.cnpj,
    },
    {
      title: "*CPF Administrador",
      placeholder: "000.000.000-00",
      mask: "CPF",
      maxLength: 14,
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cpf",
      required: "CPF é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCPF,
      isValidDesc: "CPF inválido",
      //Default
      defaultValue: defaultValueLstEmpresa?.cpf,
    },
    {
      title: "Apelido",
      placeholder: "Apelido",
      minLength: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "apelido",
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Apelido particular para empresa.",
      //Default
      defaultValue: defaultValueLstEmpresa?.apelido,
    },
    {
      title: "*Razão Social",
      placeholder: "Razão Social",
      minLength: "",
      type: "",
      theme: "3",
      col: "6",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "razaosocial",
      required: "Razão Social é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.razaosocial,
    },
    {
      title: "Inscrição Estadual",
      placeholder: "Incrição Estadual",
      maxLength: 14,
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "inscricaoestadual",
      //Default
      defaultValue: defaultValueLstEmpresa?.inscricaoestadual,
    },
    {
      title: "Nome Fantasia",
      placeholder: "Nome Fantasia",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "nomefantasia",
      //Default
      defaultValue: defaultValueLstEmpresa?.nomefantasia,
    },
    {
      title: "*Situação",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Ativa" },
        { id: 1, key: "Inativa" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "situacao",
      required: "Situação é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.situacao,
    },
    {
      title: "Data Situação",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtsituacao",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstEmpresa?.dtsituacao,
    },
    {
      title: "*Tributação",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Lucro Presumido" },
        { id: 1, key: "Lucro Real" },
        { id: 2, key: "Simples Nacional" },
        { id: 3, key: "MEI" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "tributacao",
      required: "Tributação é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.tributacao,
    },
    {
      title: "*Optante pelo simples?",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Sim" },
        { id: 1, key: "Não" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "optantepelosimples",
      required: "Campo optante pelo simples é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.optantepelosimples,
    },
    {
      title: "Data Entrada",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtentrada",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstEmpresa?.dtentrada,
    },
    {
      title: "*Data Abertura",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "dtabertura",
      required: "Data abertura é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstEmpresa?.dtabertura,
    },
    {
      title: "*Código CCM",
      placeholder: "000.000.000-00",
      mask: "CCM",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "codigoccm",
      required: "Código CCM é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCCM,
      isValidDesc: "CCM inválido",
      //Default
      defaultValue: defaultValueLstEmpresa?.codigoccm,
    },
    {
      title: "Segmento",
      placeholder: "Segmento",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "segmento",
      //Default
      defaultValue: defaultValueLstEmpresa?.segmento,
    },
    {
      title: "Capital Social",
      placeholder: "R$ 0,00",
      mask: "Valores",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "capitalsocial",
      //Default
      defaultValue: defaultValueLstEmpresa?.capitalsocial,
    },
    {
      title: "Porte",
      placeholder: "Porte",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "porte",
      //Default
      defaultValue: defaultValueLstEmpresa?.porte,
    },
    {
      title: "Tipo",
      placeholder: "Tipo",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "tipo",
      //Default
      defaultValue: defaultValueLstEmpresa?.tipo,
    },
    {
      title: "*CNAE Principal",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "9",
      tipo: "dropdownlist",
      data: cnaeLst,
      loading: loadingDropCnae,
      setLoading: setLoadingDropCnae,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleGetCNAES, //Funcão para carregar o dropdownlst
      name: "cnae",
      obrigatorio: true, //Item para campo obrigatorio
      required: "CNAE é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.cnae,
    },
    {
      title: "NIRE",
      placeholder: "NIRE",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "nire",
      type: "number",
      //Default
      defaultValue: defaultValueLstEmpresa?.nire,
    },
    {
      title: "CNAE Secundários",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "9",
      tipo: "dropdownlist",
      data: cnaeLst,
      loading: loadingDropCnae,
      setLoading: setLoadingDropCnae,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleGetCNAES, //Funcão para carregar o dropdownlst
      name: "cnaesecundario",
      adicionar: true,
      ocultar: editEmpresa ? true : false,
      //Button
      button: true,
      iconButton: "Criar",
      titleButton: "Adicionar CNAE Secundários",
      typeButton: "button",
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Adicione mais de um CNAE clicando no botão '+' ou selecione apenas um da lista.",
      //Default
      defaultValue: defaultValueLstEmpresa?.cnaesecundario,
    },
    {
      title: "Natureza Jurídica",
      placeholder: "Natureza Jurídica",
      minLength: "",
      type: "",
      theme: "3",
      col: "9",
      tipo: "input",
      name: "naturezajuridica",
      //Default
      defaultValue: defaultValueLstEmpresa?.naturezajuridica,
    },
    {
      title: "*Possui Folha?",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Sim" },
        { id: 1, key: "Não" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "possuifolha",
      required: "Possui Folha é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.possuifolha,
    },
    {
      title: "Situação Financeira",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Em dia" },
        { id: 1, key: "Atrasado" },
      ],
      name: "situacaofinanceira",
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Situação financeira com fornecedores e prestadores de serviço, como contabilidade, advocacia e tecnologia.",
      //Default
      defaultValue: defaultValueLstEmpresa?.situacaofinanceira,
    },
    {
      title: "Situação Financeira Receita",
      placeholder: "Situação Financeira Receita",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "situacaofinanceirareceita",
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Situação financeira conforme os registros oficiais da Receita Federal.",
      //Default
      defaultValue: defaultValueLstEmpresa?.situacaofinanceirareceita,
    },
    {
      title: "Observação",
      placeholder: "Observação",
      minLength: "",
      type: "",
      theme: "3",
      col: "12",
      tipo: "input",
      name: "observacao",
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Adicione aqui qualquer observação extra que você considerar importante.",
      //Default
      defaultValue: defaultValueLstEmpresa?.observacao,
    },
  ];
  /*---Lst Endereço--*/
  const lstEndereco = [
    {
      title: "*CNPJ",
      placeholder: "00.000.000/0000-00",
      mask: "CNPJ",
      maxLength: 18,
      minLength: "",
      ocultar: handleOcultarCampo("cnpj", "endereco"),
      disabled: criarEndereco, //Igual a true vai desabilitar o campo.
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cnpj",
      required: "CNPJ é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.cnpj,
    },
    {
      title: "*CPF",
      placeholder: "000.000.000-00",
      mask: "CPF",
      maxLength: 14,
      minLength: "",
      ocultar: handleOcultarCampo("cpf", "endereco"),
      disabled: criarEndereco, //Igual a true vai desabilitar o campo.
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cpf",
      required: "CPF é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCPF,
      isValidDesc: "CPF inválido",
      //Default
      defaultValue: defaultValueLstSocio?.cpf,
    },
    {
      //Forma de quebrar a linha
      subtitulo: "",
      iconSubTitulo: "",
      ocultar: criarEndereco ? false : true,
    },
    {
      title: "*CEP",
      placeholder: "00000-000",
      mask: "CEP",
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cep",
      required: "CEP é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCEP,
      isValidDesc: "CEP inválido",
      //Button
      button: true,
      iconButton: "pesquisar",
      titleButton: "Pesquisar CEP",
      typeButton: "button",
      onClickButton: handlePesquisaEndereco,
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Digite o CEP e clique no ícone de pesquisa para buscar e preencher os campos automaticamente!",
      //Default
      defaultValue: defaultValueLstEndereco?.cep,
    },
    {
      title: "Logradouro",
      placeholder: "Logradouro",
      minLength: "",
      type: "",
      theme: "3",
      col: "9",
      tipo: "input",
      name: "logradouro",
      defaultValue: defaultValueLstEndereco?.logradouro,
    },
    {
      title: "Bairro",
      placeholder: "Bairro",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "bairro",
      defaultValue: defaultValueLstEndereco?.bairro,
    },
    {
      title: "Pais",
      placeholder: "Pais",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "pais",
      defaultValue: defaultValueLstEndereco?.pais,
    },
    {
      title: "Número",
      placeholder: "Número",
      minLength: "",
      type: "",
      theme: "3",
      col: "2",
      tipo: "input",
      name: "numero",
      type: "number",
      defaultValue: defaultValueLstEndereco?.numero,
    },
    {
      title: "Complemento",
      placeholder: "Complemento",
      minLength: "",
      type: "",
      theme: "3",
      col: "5",
      tipo: "input",
      name: "complemento",
      defaultValue: defaultValueLstEndereco?.complemento,
    },
    {
      title: "Município + UF",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "5",
      tipo: "dropdownlist",
      data: municipio,
      loading: loadingDrop,
      setLoading: setLoadingDrop,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleGetMunicipiosUF, //Funcão para carregar o dropdownlst
      name: "municipio",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Município é obrigatório", //Item para campo obrigatorio
      defaultValue: defaultValueLstEndereco?.municipio,
    },
    {
      title: "*Tipo Endereço",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 1, key: "Residencial" },
        { id: 2, key: "Comercial" },
        { id: 3, key: "Entrega" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "tipoendereco",
      required: "Tipo Endereço é obrigatório", //Item para campo obrigatorio
      defaultValue: defaultValueLstEndereco?.tipoendereco,
    },
  ];
  /*---Lst Telefone--*/
  const lstTelefone = [
    {
      title: "*Nome",
      placeholder: "Nome",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "nome",
      required: "Nome é obrigatório", //Item para campo obrigatorio
    },
    {
      title: "*Telefone",
      placeholder: "DDD + Telefone",
      minLength: "",
      type: "phone",
      mask: "telefone",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "telefone",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Nome é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validatePhone,
      isValidDesc: "Telefone inválido",
      defaultValue: defaultValueLstTelefone?.telefone,
    },
    {
      title: "Email",
      placeholder: "Email",
      minLength: "",
      type: "",
      mask: "email",
      theme: "3",
      col: "9",
      tipo: "input",
      name: "email",
      isValid: UtilServices.validateEmail,
      isValidDesc: "Email inválido",
      defaultValue: defaultValueLstTelefone?.email,
    },
    {
      title: "*Tipo Contato",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: tpTelefone,
      loading: loadingTpTelefone,
      setLoading: setLoadingTpTelefone,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleConsultaTipoContato_DropDownLst, //Funcão para carregar o dropdownlst
      obrigatorio: true, //Item para campo obrigatorio
      name: "tipocontato",
      required: "Tipo Contato é obrigatório", //Item para campo obrigatorio
      defaultValue: defaultValueLstEndereco?.tipocontato,
    },
  ];
  /*---Lst Socio--*/
  const lstSocio = [
    {
      title: "*CNPJ",
      placeholder: "00.000.000/0000-00",
      mask: "CNPJ",
      maxLength: 18,
      minLength: "",
      ocultar: !criarSocio,
      disabled: criarSocio, //Igual a true vai desabilitar o campo.
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cnpj",
      required: "CNPJ é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstEmpresa?.cnpj,
    },
    {
      //Forma de quebrar a linha
      subtitulo: "",
      iconSubTitulo: "",
      ocultar: criarSocio ? false : true,
    },
    {
      title: "*Nome Completo",
      placeholder: "Nome Completo",
      minLength: "",
      type: "nomesobrenome",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "nomecompleto",
      required: "Nome completo é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.nomecompleto,
    },
    {
      title: "*CPF",
      placeholder: "000.000.000-00",
      mask: "CPF",
      maxLength: 14,
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cpf",
      required: "CPF é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCPF,
      isValidDesc: "CPF inválido",
      //Default
      defaultValue: defaultValueLstSocio?.cpf,
    },
    {
      title: "*Sexo",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 1, key: "Masculino" },
        { id: 2, key: "Feminino" },
      ],
      obrigatorio: true, //Item para campo obrigatorio
      name: "sexo",
      required: "Campo sexo é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.sexo,
    },
    {
      title: "RG",
      placeholder: "RG",
      minLength: "",
      type: "",
      mask: "RG",
      maxLength: 12,
      theme: "3",
      col: "3",
      tipo: "input",
      name: "rg",
      //Default
      defaultValue: defaultValueLstSocio?.rg,
    },
    {
      title: "*Data Nascimento",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      type: "",
      mask: "Date",
      theme: "3",
      col: "3",
      tipo: "input",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      obrigatorio: true, //Item para campo obrigatorio
      name: "dtnascimento",
      required: "Data Nascimento é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.dtnascimento,
    },
    {
      title: "*Nacionalidade",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: lstNacionalidade,
      obrigatorio: true, //Item para campo obrigatorio
      name: "nacionalidade",
      required: "Nacionalidade é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.nacionalidade,
    },
    {
      title: "Município + UF (Nascimento)",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "5",
      tipo: "dropdownlist",
      data: municipio,
      loading: loadingDrop,
      setLoading: setLoadingDrop,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleGetMunicipiosUF, //Funcão para carregar o dropdownlst
      name: "municipionascimento",
      //Default
      defaultValue: defaultValueLstSocio?.municipionascimento,
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Municipio e UF de nascimento!",
    },
    {
      title: "Profissão",
      placeholder: "Profissão",
      minLength: "",
      type: "document",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "profissao",
      //Default
      defaultValue: defaultValueLstSocio?.profissao,
    },
    {
      title: "Estado Civil",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 1, key: "Casado(a)" },
        { id: 2, key: "Solteiro(a)" },
      ],
      name: "estadocivil",
      //Default
      defaultValue: defaultValueLstSocio?.estadocivil,
    },
    {
      title: "PIS",
      placeholder: "pis",
      maxLength: 11,
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "pis",
      //Default
      defaultValue: defaultValueLstSocio?.pis,
    },
    {
      title: "Titulo Eleitor",
      placeholder: "Titulo Eleitor",
      maxLength: 12,
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "tituloeleitor",
      //Default
      defaultValue: defaultValueLstSocio?.tituloeleitor,
    },
    {
      subtitulo: "Dados Sócio",
      iconSubTitulo: <i className="fa-solid fa-database"></i>,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Data Inclusão",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtinclusao",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Data Inclusão é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.dtinclusao,
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Data da inclusão do socio na empresa!",
      ocultar: editSocio ? true : false,
    },
    {
      title: "Data Exclusão",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtexclusao",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstSocio?.dtexclusao,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Participação Capital",
      placeholder: "R$ 0,00",
      mask: "Valores",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "participacaocapital",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Participação Capital é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.participacaocapital,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Status",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Ativo" },
        { id: 1, key: "Inativo" },
      ],
      name: "status",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Status é obrigatório", //Item para campo obrigatorio
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Socio Responsável",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Sim" },
        { id: 1, key: "Não" },
      ],
      name: "socioresponsavel",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Socio Responsável é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.socioresponsavel,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Porcentagem Lucro",
      placeholder: "Porcentagem Lucro",
      minLength: "",
      mask: "Porcentagem",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "porcentagemlucro",
      ocultar: editSocio ? true : false,
    },
    {
      title: "Valor Bruto (Prolabore)",
      placeholder: "R$ 0,00",
      mask: "Valores",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "valorbrutoprolabore",
      ocultar: editSocio ? true : false,
    },
    {
      title: "Período Referente (Prolabore)",
      placeholder: "MM/YYYY",
      maxLength: 7,
      mask: "mesAno",
      minLength: "",
      type: "",
      theme: "3",
      col: "4",
      tipo: "input",
      name: "periodoreferenteprolabore",
      isValid: UtilServices.validateMonthYear,
      isValidDesc: "Data inválido",
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Última atualização do período de prolabore",
      ocultar: editSocio ? true : false,
    },
    {
      subtitulo: "Endereço Socio",
      iconSubTitulo: <i className="fa-solid fa-location-dot"></i>,
      ocultar: editSocio ? true : false,
    },
    {
      title: "CEP",
      placeholder: "00000-000",
      mask: "CEP",
      minLength: "",
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "cep",
      isValid: UtilServices.validateCEP,
      isValidDesc: "CEP inválido",
      //Button
      button: true,
      iconButton: "pesquisar",
      titleButton: "Pesquisar CEP",
      typeButton: "button",
      onClickButton: handlePesquisaEnderecoSocio,
      //ToolTip
      tooltip: true,
      tooltipDescricao:
        "Digite o CEP e clique no ícone de pesquisa para buscar e preencher os campos automaticamente!",
      //Default
      defaultValue: defaultValueLstSocio?.cep,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Logradouro",
      placeholder: "Logradouro",
      minLength: "",
      type: "",
      theme: "3",
      col: "9",
      tipo: "input",
      name: "logradouro",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.logradouro,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Bairro",
      placeholder: "Bairro",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "bairro",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.bairro,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Pais",
      placeholder: "Pais",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "pais",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.pais,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Número",
      placeholder: "Número",
      minLength: "",
      type: "",
      theme: "3",
      col: "2",
      tipo: "input",
      name: "numero",
      type: "number",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.numero,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Complemento",
      placeholder: "Complemento",
      minLength: "",
      type: "",
      theme: "3",
      col: "5",
      tipo: "input",
      name: "complemento",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.complemento,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Município + UF",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "5",
      tipo: "dropdownlist",
      data: municipio,
      loading: loadingDrop,
      setLoading: setLoadingDrop,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleGetMunicipiosUF, //Funcão para carregar o dropdownlst
      name: "municipio",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.municipio,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Tipo Endereço",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 1, key: "Residencial" },
        { id: 2, key: "Comercial" },
        { id: 3, key: "Entrega" },
      ],
      name: "tipoendereco",
      //DEFAULT
      defaultValue: defaultValueLstSocio?.tipoendereco,
      ocultar: editSocio ? true : false,
    },
    {
      subtitulo: "Telefone Socio",
      iconSubTitulo: <i className="fa-solid fa-phone-plus"></i>,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Telefone",
      placeholder: "DDD + Telefone",
      minLength: "",
      type: "phone",
      mask: "telefone",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "telefone",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Nome é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validatePhone,
      isValidDesc: "Telefone inválido",
      defaultValue: defaultValueLstTelefone?.telefone,
      ocultar: editSocio ? true : false,
    },
    {
      title: "Email",
      placeholder: "Email",
      minLength: "",
      type: "",
      mask: "email",
      theme: "3",
      col: "9",
      tipo: "input",
      name: "email",
      isValid: UtilServices.validateEmail,
      isValidDesc: "Email inválido",
      defaultValue: defaultValueLstTelefone?.email,
      ocultar: editSocio ? true : false,
    },
    {
      title: "*Tipo Contato",
      placeholder: "Selecione",
      maxLength: 15,
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: tpTelefone,
      loading: loadingTpTelefone,
      setLoading: setLoadingTpTelefone,
      //Carregar ao clicar
      flgCarregarClick: true,
      functionCarregarClick: handleConsultaTipoContato_DropDownLst, //Funcão para carregar o dropdownlst
      obrigatorio: true, //Item para campo obrigatorio
      name: "tipocontato",
      required: "Tipo Contato é obrigatório", //Item para campo obrigatorio
      defaultValue: defaultValueLstEndereco?.tipocontato,
      ocultar: editSocio ? true : false,
    },
  ];
  /*---Lst Socio Vinculo--*/
  const lstSocioVinculo = [
    {
      title: "*CPF",
      placeholder: "000.000.000-00",
      mask: "CPF",
      maxLength: 14,
      minLength: "",
      disabled: criarDadosSocio || editDadosSocio, //Igual a true vai desabilitar o campo.
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cpf",
      required: "CPF é obrigatório", //Item para campo obrigatorio
      isValid: UtilServices.validateCPF,
      isValidDesc: "CPF inválido",
      //Default
      defaultValue: defaultValueLstSocio?.cpf,
    },
    {
      //Forma de quebrar a linha
      subtitulo: "",
      iconSubTitulo: "",
      ocultar: criarDadosSocio ? false : true,
    },
    {
      title: "*CNPJ",
      placeholder: "00.000.000/0000-00",
      mask: "CNPJ",
      maxLength: 18,
      minLength: "",
      disabled: editDadosSocio, //Igual a true vai desabilitar o campo.
      type: "number",
      theme: "3",
      col: "3",
      tipo: "input",
      obrigatorio: true, //Item para campo obrigatorio
      name: "cnpj",
      required: "CNPJ é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.cnpj,
    },
    {
      title: "*Data Inclusão",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtinclusao",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Data Inclusão é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.dtinclusao,
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Data da inclusão do socio na empresa!",
    },
    {
      title: "Data Exclusão",
      placeholder: "DD/MM/YYYY",
      maxLength: 15,
      mask: "Date",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "dtexclusao",
      isValid: UtilServices.validateDate,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstSocio?.dtexclusao,
    },
    {
      title: "*Participação Capital",
      placeholder: "R$ 0,00",
      mask: "Valores",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "participacaocapital",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Participação Capital é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.participacaocapital,
    },
    {
      title: "Porcentagem Lucro",
      placeholder: "Porcentagem Lucro",
      minLength: "",
      mask: "Porcentagem",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "porcentagemlucro",
      //Default
      defaultValue: defaultValueLstSocio?.porcentagemlucro,
    },
    {
      title: "*Status",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Ativo" },
        { id: 1, key: "Inativo" },
      ],
      name: "status",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Status é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.status,
    },
    {
      title: "*Socio Responsável",
      placeholder: "Selecione",
      minLength: "",
      type: "",
      theme: "2",
      col: "3",
      tipo: "dropdownlist",
      data: [
        { id: 0, key: "Sim" },
        { id: 1, key: "Não" },
      ],
      name: "socioresponsavel",
      obrigatorio: true, //Item para campo obrigatorio
      required: "Socio Responsável é obrigatório", //Item para campo obrigatorio
      //Default
      defaultValue: defaultValueLstSocio?.socioresponsavel,
    },
    {
      title: "Valor Bruto (Prolabore)",
      placeholder: "R$ 0,00",
      mask: "Valores",
      minLength: "",
      type: "",
      theme: "3",
      col: "3",
      tipo: "input",
      name: "valorbrutoprolabore",
      //Default
      defaultValue: defaultValueLstSocio?.valorbrutoprolabore,
    },
    {
      title: "Período Referente (Prolabore)",
      placeholder: "MM/YYYY",
      maxLength: 7,
      mask: "mesAno",
      minLength: "",
      type: "",
      theme: "3",
      col: "4",
      tipo: "input",
      name: "datapagamentoprolabore",
      isValid: UtilServices.validateMonthYear,
      isValidDesc: "Data inválido",
      //Default
      defaultValue: defaultValueLstSocio?.datapagamentoprolabore,
      //ToolTip
      tooltip: true,
      tooltipDescricao: "Última atualização do período de prolabore",
    },
  ];

  console.log("submit", submit);

  return (
    <div className="cadcadastro">
      {!editEndereco &&
        !editSocio &&
        !editDadosSocio &&
        !criarSocio &&
        !criarEndereco &&
        !criarDadosSocio && (
          //Empresa
          <FormCadastro
            handleSubmit={(e) => {
              setSubmit((prevState) => ({
                ...prevState,
                dadosempresa: [e],
              }));
              setCnpj(e.cnpj);
            }}
            setKeyValidation={setCnpj} //Editar o validation
            setSubmit={setSubmit}
            keySubmit={"dadosempresa"}
            limpar={limpar}
            setLimpar={setLimpar}
            lst={lstEmpresa}
            save //Botão
            titleSalvar="Salvar" //Botão
            clear //Botão
            titleClear="Limpar Formulário" //Botão
            icon={<i className="fa-solid fa-user-plus"></i>}
            title={"* Dados Empresa"}
            setDefaultValueLst={setDefaultValueLstEmpresa}
            defaultValueLst={defaultValueLstEmpresa}
          />
        )}
      {!editEmpresa &&
        !editSocio &&
        !editDadosSocio &&
        !criarSocio &&
        !criarDadosSocio && (
          //Endereco
          <FormCadastro
            handleSubmit={(e) => {
              handleInsertSubmit("endereco", e);
            }}
            //o keyvalidation não pode ser undefined caso queira validar
            {...(!idSocio && {
              keyValidation: cnpj, //Validação de um campo que não pode ser nulo aqui fora.
            })}
            messageValidation={"É necessário realizar o cadastro do CNPJ."}
            setSubmit={setSubmit}
            keySubmit={"endereco"}
            limpar={limpar}
            setLimpar={setLimpar}
            lst={lstEndereco}
            save //Botão
            titleSalvar="Salvar" //Botão
            // adicionar //Botão
            // titleAdicionar="Adicionar na lista" //Botão
            clear //Botão
            titleClear="Limpar Formulário" //Botão
            icon={<i className="fa-solid fa-location-dot"></i>}
            title={"* Endereço"}
            setDefaultValueLst={setDefaultValueLstEndereco}
            defaultValueLst={defaultValueLstEndereco}
          />
        )}
      {!editEmpresa &&
        !editEndereco &&
        !editSocio &&
        !editDadosSocio &&
        !criarSocio &&
        !criarEndereco &&
        !criarDadosSocio && (
          //Telefone
          <FormCadastro
            handleSubmit={(e) => {
              handleInsertSubmit("telefone", e);
            }}
            keyValidation={cnpj} //Validação de um campo que não pode ser nulo aqui fora.
            messageValidation={"É necessário realizar o cadastro do CNPJ."}
            limpar={limpar}
            setLimpar={setLimpar}
            setSubmit={setSubmit}
            keySubmit={"telefone"}
            lst={lstTelefone}
            save //Botão
            titleSalvar="Salvar" //Botão
            adicionar //Botão
            titleAdicionar="Adicionar na lista" //Botão
            clear //Botão
            titleClear="Limpar Formulário" //Botão
            icon={<i className="fa-solid fa-phone-plus"></i>}
            title={"Telefone"}
            setDefaultValueLst={setDefaultValueLstTelefone}
            defaultValueLst={defaultValueLstTelefone}
          />
        )}
      {!editEmpresa &&
        !editEndereco &&
        !criarEndereco &&
        !criarDadosSocio &&
        !editDadosSocio && (
          //Socio
          <FormCadastro
            handleSubmit={(e) => {
              handleInsertSubmit("socio", e);
            }}
            //o keyvalidation não pode ser undefined caso queira validar
            {...(idSocio
              ? { keyValidation: idSocio }
              : {
                  keyValidation: cnpj,
                  messageValidation:
                    "É necessário realizar o cadastro do CNPJ.",
                })}
            setSubmit={setSubmit}
            keySubmit={"socio"}
            limpar={limpar}
            setLimpar={setLimpar}
            lst={lstSocio}
            save //Botão
            titleSalvar="Salvar" //Botão
            {...(!editSocio &&
              !criarSocio && {
                adicionar: true, //Botão
                titleAdicionar: "Adicionar na lista", //Botão
              })}
            clear //Botão
            titleClear="Limpar Formulário" //Botão
            icon={<i className="fa-solid fa-handshake"></i>}
            title={"Sócio"}
            setDefaultValueLst={setDefaultValueLstSocio}
            defaultValueLst={defaultValueLstSocio}
          />
        )}
      {/* Esse formulario so é aberto quando for criar um novo ou fazer edições */}
      {(criarDadosSocio || editDadosSocio) && (
        //Dados do Socio
        <FormCadastro
          handleSubmit={(e) => {
            handleInsertSubmit("dadossocio", e);
          }}
          keyValidation={idSocio} //Validação de um campo que não pode ser nulo aqui fora.
          messageValidation={"Sócio não vinculado!"}
          limpar={limpar}
          setLimpar={setLimpar}
          setSubmit={setSubmit}
          keySubmit={"telefone"}
          lst={lstSocioVinculo}
          save //Botão
          titleSalvar="Salvar" //Botão
          // adicionar //Botão
          // titleAdicionar="Adicionar na lista" //Botão
          clear //Botão
          titleClear="Limpar Formulário" //Botão
          icon={<i className="fa-solid fa-database"></i>}
          title={"Dados do Sócio"}
          setDefaultValueLst={setDefaultValueLstSocio}
          defaultValueLst={defaultValueLstSocio}
        />
      )}
      <div className="cadcadastro-button">
        <Button
          nome="Salvar"
          theme="3"
          title="Salvar Dados"
          onClick={() => {
            if (editEmpresa || editEndereco || editSocio || editDadosSocio) {
              handleEditar();
            } else {
              handleAdicionar();
            }
          }}
          disabled={handleDisabledSalvar()}
        />
      </div>
    </div>
  );
};

export default CadCadastro;
